import { graphql } from '../gql';
import { useQuery } from '@apollo/client';
import type { ClaimFilterInput } from '../gql/graphql';

export const GET_CLAIM_INFORMATION = graphql(`
  query getClaimInformation($filters: ClaimFilterInput) {
    claims(filters: $filters) {
      edges {
        node {
          uuid
          reportedDate
          rorSentDate
          mitreAttackNotApplicable
          mitreAttackReceivedDate
          mitreAttackSentDate
          declinationSent
          polSentDate
          polSentDateNa
          rorSentDateNa
          lossDate
          closedDate
          referenceId
          additionalCoveragesImpacted
          lossTypes
          potentialCoveragesImpacted
        }
      }
    }
  }
`);

export interface IUseClaimInformationQueryArg {
  filters?: ClaimFilterInput;
}

export function useClaimInformationQuery(claimUuid: string) {
  const { loading, data, error } = useQuery(GET_CLAIM_INFORMATION, {
    variables: {
      filters: { claimUuid },
    },
  });

  return {
    loading,
    error,
    data,
  };
}
